/* eslint-disable no-param-reassign */
import { useMemo, useState, useEffect } from 'react';
import { Xperimenta as XperimentaPortal } from '@uaveiro/ui';
import { withPortalProviders } from 'modules/utils';
import { getCourseInfo } from 'services/requests'
import get from 'lodash.get'


const generateNewFilter = (value, initialFilter) => {
  // handle delete all
  if (value === null) return [];

  const newFilter = [...initialFilter];
  // handle add one
  if (!newFilter.includes(value)) {
    newFilter.push(value);
  } else {
    // handle delete one
    newFilter.splice(newFilter.indexOf(value), 1);
  }
  return newFilter;
};

const Xperimenta = ({
  lang, sessions, title
}) => {
  const [state, setState] = useState({
    isLoading: true,
    hasError: false,
    filters: [],
    data: [],
    buttons: [],
    staticData: [],
    defaultValues: {
      degree: '',
      knowledgeAreas: ''
    },
  });

  // currently applied filters
  const [activeFilters, setActiveFilters] = useState({
    type: [],
    knowledgeAreas: []
  });

  const orderByDegree = degrees => degrees.sort((firstElement, secondElement) => {
    if (
      firstElement.value
        ? firstElement.value === '10'
        : firstElement.type === 10
    ) {
      return -1;
    }
    if (
      secondElement.value
        ? secondElement.value === '2'
        : secondElement.type === 2
    ) {
      return 1;
    }
    return 0;
  });

  const getData = async () => {
    try {
      const { data: res } = await getCourseInfo({
        lang
      });

      const orderedButtons = res.data.buttons.map(
        button => ({ ...button, options: orderByDegree(button.options) }));

      setState(prevState => ({
        ...prevState,
        data: res.data.list,
        buttons: orderedButtons,
        staticData: res.data.list,
        filters: res.data.filters,
        isLoading: false,
        sessions
      }));
    } catch (error) {
      setState(prevState => ({ ...prevState, isLoading: false, hasError: true }));
    }
  };

  const onChangeFilter = (option, field) => {
    setActiveFilters({
      ...activeFilters,
      [field]: generateNewFilter(
        get(option, 'value', null),
        activeFilters[field]
      )
    });
  };

  const handleFilterData = filters => {
    const { type, knowledgeAreas } = filters;

    // order the data rendered with no filters
    let filteredData = orderByDegree(state.staticData);
    // filter degrees
    if (type.length > 0) {
      filteredData = filteredData.filter(
        degreeData => type.find(deg => degreeData.type.toString() === deg));
    }

    // filter degrees
    if (type.length > 0) {
      filteredData = filteredData.filter(
        degreeData => type.find(deg => degreeData.type.toString() === deg
        )
      );
    }

    // filter knowledge areas
    if (knowledgeAreas.length > 0) {
      filteredData = filteredData.map(degree => {
        const filteredList = degree.list.reduce((acc, area) => {
          // no knowleged area, so skip
          if (area.knowledgeAreas.length === 0) return acc;

          // check if knowleged area matches filter and add
          const knowledgeAreasMatch = knowledgeAreas.filter(
            knowledgeAreaFilter => area.knowledgeAreas.includes(knowledgeAreaFilter)
          );
          if (knowledgeAreasMatch.length > 0) return acc.concat(area);

          // otherwise skip
          return acc;
        }, []);

        return {
          ...degree,
          list: filteredList
        };
      });
    }
    setState({ ...state, data: filteredData });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleFilterData(activeFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters, state.staticData]);


  const computedProps = useMemo(() => {
    // do the convertion logic here
    const {
      isLoading,
      hasError,
      data,
      buttons,
      defaultValues,
      filters
    } = state;
    const newProps = {
      isLoading,
      hasError,
      data,
      buttons,
      defaultValues,
      filters,
      onChangeFilter,
      title,
      sessions,
      lang

    }
    return newProps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, sessions, title])

  return withPortalProviders(XperimentaPortal, computedProps);
};
export default Xperimenta;
